import React from 'react';
import { useLanguage } from '../../LanguageContext';
import {Card} from "react-bootstrap";
import "../../styles/artist.css"
const Management = () => {

    const { translations } = useLanguage();
    return (
    <Card className="section-card">
        <Card.Body>
            <Card.Title>
                <h1>{translations.manager.title}</h1>
                <img
                    src="/images/Felix-Main.png"
                    alt="patrick"
                    className="rounded-circle img-fluid"
                    style={{
                        width: "100%",      // Makes it responsive
                        maxWidth: "400px",  // Limits size on large screens
                        aspectRatio: "1 / 1", // Ensures it stays a perfect square
                        objectFit: "cover",
                        borderRadius: "50%", // Ensures full roundness
                        margin: "5px"
                    }}
                />
            </Card.Title>
            <Card.Text>
                <p>{translations.manager.description}</p>
                <p>{translations.manager.role}</p>
                <p>{translations.manager.closing}</p>
                <strong>{translations.manager.cta}</strong>
            </Card.Text>
        </Card.Body>
    </Card>

    )
        ;
};

export default Management;